import AvatarCard from '../avatar-card';

interface AvatarProps {
    imageUrl: any;
    title: string;
    subTitle?: string;
    onClickHandler?: any;
    className?: any;
    size?: string;
    description?: string;
    status?: string;
}

export default function List({ imageUrl, onClickHandler, className, title, subTitle, size = 'sm', description, status }: AvatarProps) {

    const getBackgroundColor = () => {
        switch (status) {
            case 'approved':
            case 'endorsed':
                return "bg-approvedLight";
            case 'rejected':
            case 'disagreed':
                return "bg-rejectLight";
            case 'pending':
                return "bg-grayCol";
            default:
                return "";
        }
    };

    return (
        <div className={`flex flex-col p-3 mb-3 last:mb-0 rounded-basicRadius ${getBackgroundColor()} ${className}`} onClick={onClickHandler} >
            <AvatarCard imageUrl={imageUrl} title={title} subTitle={subTitle} size={size} status={status} isViewMore={false} />
            {status !== 'pending' && <div className={`text-labelTextCol font-aeonikReg text-sm mt-2 ${description?.includes("No comments added") ? '!text-gray-500' : ''}`}>
                {description}
            </div>}
        </div>
    );
};